module.exports = __webpack_public_path__ + "static/media/video-camera.8f98bf23.svg";